import i18next, { Locale } from './config'

export type { Locale }
export { i18next }
